import React, { useEffect, useRef } from "react";
import { debounce } from "../utils/debounce";

const Chat = (sidebarCollapsed) => { 
    const sidebarRef = useRef();

    useEffect(() => {
        const handleResize = debounce(() => {
          const { current: sidebarEl } = sidebarRef;
    
          if (sidebarEl) {
            sidebarEl.style.width = sidebarEl.parentNode.offsetWidth + "px";
          }
        }, 350);
    
        window.addEventListener("resize", handleResize);
        handleResize();
    
        return () => window.removeEventListener("resize", handleResize);
      }, [sidebarCollapsed]);

    return (
        <div
            ref={sidebarRef}
            className="context-sidebar col-sm-12 col-md-4 col-xl-3 px-0 vh-100 border-left fixed-md">
            
        </div>
    );
};
      
export default Chat;
